import type { ScheduledProcedure, ScheduleToken } from './scheduleColumnPacking';
import { formatPatientSummary, formatScheduleTime, normalizeScheduleText } from './scheduleColumnText';

export { formatPatientSummary, formatScheduleTime } from './scheduleColumnText';

export type ScheduleTokenPresentation =
  | { kind: 'header'; time: string }
  | {
      kind: 'card';
      procedure: ScheduledProcedure;
      startTime: string;
      finishTime: string;
      patientSummary: string;
      physicianLabel: string;
      durationMinutes: number | null;
    };

export const presentScheduleToken = (token: ScheduleToken): ScheduleTokenPresentation => {
  if (token.kind === 'header') return token;

  return {
    kind: 'card',
    procedure: token.procedure,
    startTime: formatScheduleTime(token.procedure.startTimeText),
    finishTime: formatScheduleTime(token.procedure.endTimeText),
    patientSummary: formatPatientSummary(token.procedure),
    physicianLabel: normalizeScheduleText(token.procedure.physicianName) ?? '–',
    durationMinutes: token.procedure.duration ?? null,
  };
};
